<template>
  <svg
    :width.attr="Number(size) || 24"
    :height.attr="Number(size) || 24"
    :viewBox.attr="getViewBox"
    :style="iconStyle"
    class="vf-a-icon"
  >
    <path :d.attr="icon" />
  </svg>
</template>
<script lang="ts" setup>
import { computed, PropType } from "vue";
const props = defineProps({
  flip: { type: String, default: "none" },
  rotate: { type: Number, default: 0 },
  test: {
    type: String,
    default() {
      return "ab-testing";
    },
  },
  size: {
    type: [Number, String] as PropType<number | string>,
    default() {
      return 15;
    },
  },
  icon: {
    type: String,
    default() {
      return null;
    },
  },
});
// Preserve the previous icon transform contract. Explicit SVG attributes
// avoid writes to read-only SVG DOM properties during Vue hydration.
const iconStyle = computed(() => ({
  "--sx": ["both", "horizontal"].includes(props.flip) ? "-1" : "1",
  "--sy": ["both", "vertical"].includes(props.flip) ? "-1" : "1",
  "--r": `${props.rotate}deg`,
}));
const getViewBox = computed(() => {
  if (props.size >= 24) {
    return `0 0 ${props.size} ${props.size}`;
  }
  return "0 0 24 24";
});
</script>
<style scoped>
svg {
  transform: rotate(var(--r, 0deg)) scale(var(--sx, 1), var(--sy, 1));
}
path {
  fill: currentColor;
}
</style>
